import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { api } from "@/lib/backend";
import { extractionWrapper } from "@/lib/backend/utils/extract";
import { ME_QUERY_KEY } from "./me.key";

export const queryOptions_me = (params: Parameters<typeof api.me.getMe>[0]) =>
  queryOptions({
    queryKey: [ME_QUERY_KEY, params] as const,
    queryFn: (context) => extractionWrapper(api.me.getMe(context.queryKey[1])),
    placeholderData: keepPreviousData, // Prevent undefined during refetch - fixes white screen on iOS
  });
